var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssignForm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4.5V7.5H7.5C6.92903 7.5 6.46519 7.69106 6.07812 8.07812C5.69106 8.46519 5.5 8.92903 5.5 9.5C5.5 10.071 5.69106 10.5348 6.07812 10.9219C6.46519 11.3089 6.92903 11.5 7.5 11.5H15.9736L13.2451 8.75195L12.8945 8.39844L15 6.29297L21.707 13L14.9971 19.71L14.6436 19.3506L13.2432 17.9258L12.8965 17.5723L13.2461 17.2217L15.9678 14.5H7.5C6.11891 14.5 4.92882 14.0108 3.95898 13.041C2.98915 12.0712 2.5 10.8811 2.5 9.5C2.5 8.11891 2.98915 6.92882 3.95898 5.95898C4.92882 4.98915 6.11891 4.5 7.5 4.5H8.5Z",
    stroke: "#ADB84E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignForm);
export default __webpack_public_path__ + "static/media/assign-form.1f95dfcc5dd78530da9c88cc59f770a7.svg";
export { ForwardRef as ReactComponent };